import {MediaItem} from '../model';

export default function GetMediaByTypes(items: MediaItem[], ...types: MediaItem['type'][]) {
    return items.filter(item => types.includes(item.type));
}

export class MediaObject {
    media: MediaItem[];
    constructor(media?: MediaItem[]) {
        this.media = media ?? [];
    }

    get photos() {
        return GetMediaByTypes(this.media, 'photo');
    }

    get files() {
        return GetMediaByTypes(this.media, 'file');
    }

    get videos() {
        return GetMediaByTypes(this.media, 'video');
    }

    get audios() {
        return GetMediaByTypes(this.media, 'audio');
    }
}
